<div
  v-if="shouldRenderConfig"
  v-bind:class="getClassName"
>
  {{$t('Customise your')}} {{getWebProductName}}
</div>
